import { render, staticRenderFns } from "./ExpandedGalleryItem.vue?vue&type=template&id=54c5ed32&"
import script from "./ExpandedGalleryItem.vue?vue&type=script&lang=js&"
export * from "./ExpandedGalleryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports